import styled from 'styled-components'

export const Select = styled.select`
    width: 13vw;
    height: 5.8vh;
    border-radius: 20px;
    border: none;
    padding: 0 4px 0 16px;
    gap: 8px;
    background-color: #EBEBEB;
    appearance: none;
`

export const Actions = styled.div`
    display: flex;
    gap: 24px;
`